import { Component, computed, inject, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { ContextService } from '../../core/context/context.service';
import { NotificationBell } from '../notifications/notification-bell.component';

@Component({
  selector: 'app-header',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatMenuModule,
    MatDividerModule,
    MatTooltipModule,
    RouterLink,
    NotificationBell,
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  readonly menuClick = output<void>();
  readonly auth = inject(AuthService);
  readonly context = inject(ContextService);
  private readonly router = inject(Router);

  /** The designations held at the user's campuses, from the context (e.g. "Dept Head"), without repeats. */
  readonly designations = computed(() => [...new Set(this.context.places().map((place) => place.designationName))]);

  /** Up to two letters for the avatar, e.g. "Ali Khan" -> "AK". */
  readonly initials = computed(() => {
    const user = this.auth.currentUser();
    const name = user?.fullName?.trim() || user?.username?.trim() || '';
    const parts = name.split(/[\s._-]+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  });

  logout(): void {
    this.auth.logout();
    void this.router.navigate(['/login']);
  }
}
